import Question from "../components/Question";
import { useNavigate } from "react-router-dom";
import { Box, TextField, FormControl, Chip, Autocomplete, useTheme } from "@mui/material";

import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setBodyPart as updateBodyPart } from '../redux/userSlice';

import parts from "../assets/body-parts.json";
import { inputLabelSx, textAreaSx } from "../lib/uiformatting";
import ContinueButton from "../components/ContinueButton";
import setPageAndDeferNavigate from "../lib/setPageAndDeferNavigate";

export default function Body() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();

    const user = useSelector((state) => state.user);
    const [bodyPart, setBodyPart] = useState(user.bodyPart.map((part) => parts[part]));
    const [error, setError] = useState("");

    // function that removes choice from options if it's already selected - messes up the tag display
    //   const refreshOptions = () => {
    //     const newOptions = {...parts};
    //     Object.keys(parts).forEach((key) => {
    //         if (!bodyPart.includes(parts[key])) {
    //             // newOptions[key] = parts[key]
    //         }
    //     });
    //     return newOptions;
    //   }

    const [options, setOptions] = useState(parts);

    //   useEffect(() => {
    //     setOptions(refreshOptions());
    //   }, [bodyPart]);

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, '/photos', navigate);
    };


    return (
        <Question
            onBack={handleBack}
            title="And where does the skin issue appear?"
            subtitle={
                <>
                    Please select the body part that appears in the photos. You can select multiple body parts.
                </>
            }
            input={
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <FormControl sx={{ width: "100%", mb: "2rem" }} required>
                        <Autocomplete
                            value={bodyPart}
                            options={Object.values(options)}
                            onChange={(e, newValue) => {
                                if (newValue.length === 0) {
                                    setError("Please select at least one option.");
                                }
                                else setError("");
                                setBodyPart(newValue);
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    id="body-parts-select"
                                    label="Search here..."
                                    variant="outlined"
                                    color="secondary"
                                    sx={{
                                        ...textAreaSx, width: "100%",
                                        "& .MuiInputLabel-root": {
                                            backgroundColor: theme.palette.background.paper,
                                            padding: "0 32px",
                                            transition: "all 0.2s ease-in-out",
                                        },
                                    }}
                                    autoComplete="off"
                                    error={error !== ""}
                                    helperText={error}
                                    InputLabelProps={{
                                        sx: {
                                            ...inputLabelSx,
                                            "& .MuiInputLabel-shrink": {
                                                backgroundColor: theme.palette.background.paper,
                                            },
                                        },
                                    }}
                                />}
                            multiple
                            renderTags={(values, getTagProps) =>
                                values.map((option, index) => (
                                    <Chip
                                        variant="outlined"
                                        sx={{
                                            fontSize: "clamp(12px, 2.5vh, 15px)",
                                            fontWeight: 600,
                                        }}
                                        label={option}
                                        {...getTagProps({ index })}
                                    />
                                ))
                            }
                        />
                    </FormControl>
                    <ContinueButton
                        onClick={() => {
                            dispatch(updateBodyPart(bodyPart.map((part) => Object.keys(options).find(key => options[key] === part))));
                            setPageAndDeferNavigate(dispatch, '/other-meds', navigate);
                        }}
                        disabled={bodyPart.length === 0}
                        title="Continue"
                        selected={bodyPart.length !== 0}
                    />
                </Box>
            }
        />
    );
}